module.exports = __webpack_public_path__ + "img/16.a6bf3734.png";